// extracted by mini-css-extract-plugin
export var active = "soilSelector-module--active--DcFB9";
export var arrow = "soilSelector-module--arrow--LcHEG";
export var container = "soilSelector-module--container--SkAEQ";
export var open = "soilSelector-module--open--y7JmL";
export var placeholder = "soilSelector-module--placeholder--oFkAi";
export var remove = "soilSelector-module--remove--eNwL+";
export var select = "soilSelector-module--select--bqJQY";
export var type = "soilSelector-module--type--alqhO";
export var typeFilter = "soilSelector-module--typeFilter--lnvd9";